// extracted by mini-css-extract-plugin
module.exports = {"space":"DeliveryPickup1_space__1bvcM","rowClass":"DeliveryPickup1_rowClass__2Qi8s","precioFinal":"DeliveryPickup1_precioFinal__cm2rF"};